import { render, staticRenderFns } from "./marketing-order-detail.vue?vue&type=template&id=06965508"
import script from "./marketing-order-detail.vue?vue&type=script&lang=js"
export * from "./marketing-order-detail.vue?vue&type=script&lang=js"
import style0 from "./marketing-order-detail.vue?vue&type=style&index=0&id=06965508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports